import { useInfiniteQuery } from '@tanstack/react-query';
import {
  getInvoices,
  GetInvoicesRequest,
  InvoiceData,
  GetInvoicesResponse,
} from '@/apis/getInvoices';

export const useInvoices = (
  request: GetInvoicesRequest | null,
  user: any,
  organization: any
) => {
  return useInfiniteQuery<
    GetInvoicesResponse,
    Error,
    InvoiceData[],
    string[],
    number
  >({
    queryKey: [
      'invoices',
      request?.OrganizationUUID || '',
      user?.UserUUID || '',
      organization?.OrgUUID || '',
    ],
    queryFn: ({ pageParam = 0 }: { pageParam: number }) => {
      const limit = 5; // Show 5 invoices per page
      return getInvoices(
        {
          OrganizationUUID: request!.OrganizationUUID,
          Limit: limit,
          Offset: pageParam * limit,
        },
        user,
        organization
      );
    },
    initialPageParam: 0,
    enabled: !!request?.OrganizationUUID,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    getNextPageParam: (
      lastPage: GetInvoicesResponse,
      allPages: GetInvoicesResponse[]
    ) => {
      // Use the HasMore flag from the backend to determine if there are more pages
      return lastPage?.HasMore ? allPages.length : undefined;
    },
    select: (data) => {
      // Flatten all pages into a single array
      return data?.pages?.flatMap((page) => page?.Invoices || []) || [];
    },
  });
};
